var render, staticRenderFns
import script from "./MainToolContainablePaneMixin.vue?vue&type=script&lang=ts&"
export * from "./MainToolContainablePaneMixin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports